import {URL_LN2} from './config';
//import {LOCAL_URL_LIN} from './config';
import { get, post, post_body } from './index';
import store from '@/store'

const URL_LN = "http://47.75.119.124:8025";
// let URL_LN2 = "http://192.168.1.221:8026";
// const URL_LN = "http://192.168.1.221:8025";
const BASE_URL = "http://47.75.119.124/Service";
const LOCAL_URL = 'http://192.168.1.221:8025';
const URL_CAO = "http://47.75.119.124";
const URL_8090 = "http://47.75.119.124:8090";

const API_LIST = {// api 列表
    "get__api__list": "/get/api/list",
    "add__task": "/add/task",
    "get__task__data": "/get/task/data",
    "get__info__data": "/get/info/data",
    "update__task": "/update/task",
    "asseta__imaging__get": "/asset/imaging/get", // 获取权益曲线图数据
    "asset__statistics": "/asset/statistics", // 获取统计
    "asset__changing__rate__get": "/asset/changing/rate/get", // 获取api 趋势图
    "get__utask__detail": '/asset/trade/records/get', // 单边api 详情获取
    "get__currency__information": '/get/currency/information', // 获取手动交易币对
    "post__manual__trading": "/manual/trading", // 手动交易提交
    "post__restore__task": "/restore/task", // 单边策略 任务继续跟随
    "post__asset__restore": "/ts2/refresh_api", // 权益继续跟随
    "post__all__restore__task": '/hedging/restore/task', // 一键保值
    "get__mobile__strategy": '/strategy/data', // 获取移动策略首页数据
    "get__mobile__api__data": '/get/api/data', // 获取用户api数据
    "add__mobile__task": '/add/task', // 添加任务
    "get__mobile__pages__data": '/get/pages/data', // 移动策略数据
    "get__mobile__task__data": '/get/task/data', // 获取移动策略任务
    'display__permission__data': '/display/permission/data', //权限
    'get_sign': '/get_sign', // 币安信号
};


// 单边策略
export function getApiList(param) {// 获取所有api列表
    let url = URL_LN + API_LIST.get__api__list;
    return get(url, param);
}

export function postUnilateralTask(param) {// 单边策略添加任务
    let url = URL_LN + API_LIST.add__task;
    return post(url, param);
}

export function postUTask() {

}

export function getUTaskEditData(param) {// 单边任务编辑回显
    let url = URL_LN+API_LIST.get__task__data;
    return get(url, param);
}

export function getUStrategyList(param) {// 获取单边策略列表
    let url = URL_LN + API_LIST.get__info__data;
    return get(url, param);
}

export function postUTaskEditData(param) {// 提交单边编辑数据
    let url = URL_LN+API_LIST.update__task;
    return post(url, param);
}

export function getUTaskDetail(param) {// 获取单边任务详情
    let url = BASE_URL + API_LIST.get__utask__detail;
    return get(url, param);
}

export function getManulCurrency(param) {// 获取手动交易币对
    let url = URL_LN + API_LIST.get__currency__information;
    return get(url, param);
}

export function postManulData(param) {// 提交手动交易数据
    let url = URL_LN + API_LIST.post__manual__trading;
    return post(url, param);
}

export function postRestoreTask(param) {// 恢复止损
    const url = URL_LN + API_LIST.post__restore__task;
    return post(url, param);
}

export function possRestoreAllTask(param) {// 一键跟随
    const url = URL_LN + API_LIST.post__all__restore__task;
    return post(url, param);
}

/**
 *  矿机
*/

export function postMillData(param) {// 获取矿机相关数据
    let url = "http://192.168.1.228:8090/predict";
    return post_body(url, param);
}


/**
 * 权益
 */

export function getAssetChartDatas(param) {
    let url = BASE_URL + API_LIST.asseta__imaging__get;
    return get(url, param);
}

export function getAssetStatic(param) {
    let url = BASE_URL + API_LIST.asset__statistics;
    return get(url, param);
}

export function getAssetApiChart(param) {// 获取api 趋势图
    let url = BASE_URL + API_LIST.asset__changing__rate__get;
    return get(url, param);
}

export function postAssetsRestore(param) { // 权益继续跟随
    const url = URL_CAO + API_LIST.post__asset__restore;
    return post(url, param);
}

/**
 * 移动策略
 */
export function getMobileStrategy() {
    const url = URL_LN2 + API_LIST.get__mobile__strategy;
    return get(url);
}

export function getMobileApiData(param) {
    const url = URL_LN2 + API_LIST.get__mobile__api__data;
    return get(url, param, false, {
        headers: {
            token: store.state.token,
        }
    })
}

export function addMobileTask(data) {
    const url = URL_LN2 + API_LIST.add__mobile__task;
    return post(url, data, false, {
        headers: {
            token: store.state.token,
        }
    })
}

export function getMobilePagesData(param) {
    const url = URL_LN2 + API_LIST.get__mobile__pages__data
    return get(url, param)
}

export function getMobileTask(param) {
    const url = URL_LN2 + API_LIST.get__mobile__task__data
    return get(url, param, false, {
        headers: {
            token: store.state.token,
        }
    })
}

export function displayPermissionData(param) {
    const url = URL_LN + API_LIST.display__permission__data
    return get(url, param, false, {
        headers: {
            token: store.state.token,
        }
    })
}

export function getSignal(param) {
    return get(URL_8090 + API_LIST.get_sign, param, false, {
        headers: {
            // Token: store.state.token,
            // 先写死
            Token: store.state.token
        },
    })
}

export function getAccountPage(param) {
    return get(URL_8090 + '/get_account_page', param, false, {
        headers: {
            // Token: store.state.token,
            // 先写死
            Token: store.state.token
        },
    })
}

export function getRecords(param) {
    return get(URL_8090 + '/get_records', param, false, {
        headers: {
            Token: store.state.token
        }
    })
}

export function getCoinRange() {
    return get(URL_8090 + '/coin_range', {}, false, {
        headers: {
            Token: store.state.token
        }
    })
}

export function postCoinRange(data) {
    return post(URL_8090 + '/coin_range', data, false, {
        headers: {
            Token: store.state.token
        }
    })
}

export function getSimulate(params) {
    return get('http://47.56.71.41:9911' + '/simulate/data', params, false)
}

export function getBinanceData(params) {
    return get('http://47.56.71.41:9015/binance/data', params, false)
}

export function getOrderData(params) {
    return get('http://47.56.71.41:9015/order/data', params, false)
}

export function postAevoTradeUpdate(data) {
    return post('http://47.56.71.41:9912' + '/aevo/trade/update', data, false)
}

export function getAevoTradeUpdate(params) {
    return get('http://47.56.71.41:9912' + '/aevo/trade/data', params, false)
}

export function getOrderDetail(params) {
    return get('http://47.56.71.41:9911' + '/order/detail', params, false)
}

// 设置币安平台杠杆倍数
export function postChangeBianceLeverage(data) {
    return post(URL_LN + '/change/binance/leverage', data, false)
}

// 获取是否跟随信号状态值
export function getIsFollowSignal(params) {
    return get(URL_LN + '/is/follow/signal', params, false)
}

//更改是否跟随信号状态值
export function postIsFollowSignal(data) {
    return post(URL_LN + '/is/follow/signal', data, false)
}

// 获取黑名单数据
export function getCurrencyBlacklist(params) {
    return get(URL_LN + '/currency/blacklist', params, false)
}

//提交黑名单数据
export function postCurrencyBlacklist(data) {
    return post(URL_LN + '/currency/blacklist', data, false)
}

// 获取币安数据
export function getServiceBAdata(params) {
    return get(URL_CAO + '/Service/BAdata/get', params, false)
}

// 获取币安信号数据
export function getSign2(params) {
    return get(URL_8090 + '/get_sign2', params, false,  {
        headers: {
            Token: store.state.token
        }
    })
}

//获取K线数据
export function getInternalBinance_k_k_datas(params) {
    return get('http://47.56.71.41:9999' + '/internal/binance_k_datas', params, false)
}